import { BaseMeiucaService, type ApiResponse } from './MeiucaService'
import { env } from '@/lib/env'
import type { DayUseOccurrenceDetail } from '../types/day-use-occurrence'
import type { HomeUpcomingDayUseOccurrenceItem } from '../types/sdui'

class DayUseService extends BaseMeiucaService {
  /**
   * Get Day Use Occurrence detail
   */
  async getDayUseOccurrenceDetail(occurrenceId: string): Promise<DayUseOccurrenceDetail> {
    const response = await this.get<ApiResponse<DayUseOccurrenceDetail>>(`/day-use/occurrences/${occurrenceId}`)
    return response.data.data
  }

  /**
   * Join a Day Use occurrence
   */
  async joinDayUseOccurrence(occurrenceId: string): Promise<void> {
    await this.post<ApiResponse<void>>(`/day-use/occurrences/${occurrenceId}/join`)
  }

  /**
   * Leave a Day Use occurrence
   */
  async leaveDayUseOccurrence(occurrenceId: string): Promise<void> {
    await this.post<ApiResponse<void>>(`/day-use/occurrences/${occurrenceId}/leave`)
  }

  /**
   * Search Day Use occurrences
   */
  async searchDayUseOccurrences(params: {
    query?: string
    date?: string
    modalities?: string[]
    lat: number
    lng: number
    limit?: number
  }): Promise<HomeUpcomingDayUseOccurrenceItem[]> {
    const queryParams = new URLSearchParams()

    if (params.query) queryParams.append('q', params.query)
    if (params.date) queryParams.append('date', params.date)
    if (params.modalities && params.modalities.length > 0) {
      params.modalities.forEach((modality) => queryParams.append('modalities', modality))
    }
    queryParams.append('lat', params.lat.toString())
    queryParams.append('lng', params.lng.toString())
    if (params.limit) queryParams.append('limit', params.limit.toString())

    const queryString = queryParams.toString()
    const url = queryString ? `/day-use/occurrences?${queryString}` : '/day-use/occurrences'

    const response = await this.get<ApiResponse<HomeUpcomingDayUseOccurrenceItem[]>>(url)
    return response.data.data
  }
}

export const dayUseService = new DayUseService({
  baseURL: env.API_URL,
  refreshEndpoint: '/v1/auth/refresh',
  cookiePrefix: '',
  debug: env.IS_DEVELOPMENT,
})
